import React, { memo, useMemo } from 'react'
import { Table, Typography } from 'antd'
import { IOrdersByMonth } from '../../model/types/types'
import './styles.css'
import { getOrdersByMonthColumns } from './columns'

const { Title, Text } = Typography
export interface OrdersByManagersTableProps {
  data?: IOrdersByMonth
}

const columns = getOrdersByMonthColumns(false)

const monthNames = {
  'Январь': 0,
  'Февраль': 1,
  'Март': 2,
  'Апрель': 3,
  'Май': 4,
  'Июнь': 5,
  'Июль': 6,
  'Август': 7,
  'Сентябрь': 8,
  'Октябрь': 9,
  'Ноябрь': 10,
  'Декабрь': 11
}

const OrdersByMonthTable = (props: OrdersByManagersTableProps) => {
  const { data } = props
  if (!data) {
    return <Typography.Text>Сервер не может найти запрошенный ресурс.</Typography.Text>
  }

  const months = useMemo(() => {
    return Object.keys(data).sort((a, b) => {
      const [aMonth, aYear] = a.split(' ')
      const [bMonth, bYear] = b.split(' ')

      const aDate = new Date(Number(aYear), monthNames[aMonth as keyof typeof monthNames])
      const bDate = new Date(Number(bYear), monthNames[bMonth as keyof typeof monthNames])

      return aDate.getTime() - bDate.getTime()
    })
  }, [data])

  return (
    <div className="orders-by-months-tables">
      {months.map(month => {
        return (
          <Table
            title={() => <Title level={5}>{month}</Title>}
            key={month}
            dataSource={data[month].managers}
            columns={columns}
            pagination={false}
            size="small"
            style={{ marginBottom: '40px' }}
            summary={() => (
              <Table.Summary fixed>
                <Table.Summary.Row>
                  {columns.map((col, index) => {
                    const key = col.dataIndex
                    const val = data[month].total[key]
                    return (
                      <Table.Summary.Cell key={key} index={index}>
                        <Text strong>{val}</Text>
                      </Table.Summary.Cell>
                    )
                  })}
                </Table.Summary.Row>
              </Table.Summary>
            )}
          />
        )
      })}
    </div>
  )
}

export default memo(OrdersByMonthTable)
